import yup from 'src/libs/yup';

const ClassificationFilterSchema = yup.object().shape({
  name: yup.string().label('Nome'),
  status: yup.string().nullable().label('Status'),
});

export default ClassificationFilterSchema;
